<template>
  <helmi-group-dashboard-card
    :initializing="loadingAgentProfit"
    class="helmi-group-dashboard-agents"
    title="Välittäjien vuoden kokonaistuotto"
    subtitle="(Brutto)"
    fullscreen
    min-height="560px"
    use-theme
  >
    <v-data-iterator
      :items="agentProfit"
      :options.sync="listOptions"
      :dark="theme === 'dark'"
      :class="{ 'dark-theme': theme === 'dark' }"
    >
      <template #default="props">
        <v-list two-line :dark="theme === 'dark'">
          <v-list-item
            v-for="(agent, index) in props.items"
            :key="agent.id"
            :disabled="processingData"
            :style="`animation-delay: ${index * 50}ms;`"
          >
            <span
              :class="colors[index % colors.length]"
              class="list-ornament"
            />
            <v-list-item-avatar class="mr-4">
              <v-img :src="agent.image"/>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-text="agent.name"/>
              <v-list-item-subtitle>
                {{ agent.company_name }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <v-icon color="pink" small>
                  phone
                </v-icon>
                {{ agent.phone }}
                <v-icon
                  color="pink"
                  small
                  class="ml-2"
                >
                  mail
                </v-icon>
                {{ agent.email }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-list-item-action-text>
                <v-chip x-small>
                  {{ agent.profit | currency }}
                </v-chip>
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </template>
    </v-data-iterator>

    <helmi-group-dashboard-agent-summary/>
  </helmi-group-dashboard-card>
</template>

<script>
import { mapState } from 'vuex';
import { EventBus } from '@/utils/eventBus';

const agentData = [{
  id: 'A110',
  name: 'Jorma Välitysmies',
  company: 'Jorman Tölli Oy',
  office: 'Turku',
  phone: '0401234032',
  email: 'jorma@jormantolli.fi',
  returns: '54600',
  avatar: 'https://randomuser.me/api/portraits/med/men/17.jpg',
}, {
  id: '2221',
  name: 'Seppo Supermyyjä',
  company: 'Jorman Mökki Oy',
  office: 'Tampere',
  phone: '0401234033',
  email: 'superseppo@jormanmokki.fi',
  returns: '120000',
  avatar: 'https://randomuser.me/api/portraits/med/men/13.jpg',
}, {
  id: '3090',
  name: 'Sirpa Suorittaja',
  company: 'Jorman Tölli Oy',
  office: 'Rauma',
  phone: '0401234034',
  email: 'sirpa@jormantolli.fi',
  returns: '99900',
  avatar: 'https://randomuser.me/api/portraits/med/women/15.jpg',
}, {
  id: 'A422',
  name: 'Irma Isännöitsijä',
  company: 'Jorman Tölli Oy',
  office: 'Turku',
  phone: '0401234235',
  email: 'sirpa@jormantolli.fi',
  returns: '88700',
  avatar: 'https://randomuser.me/api/portraits/med/women/11.jpg',
}];

const summaryData = [{
  agentId: 'A110',
  averageMediationPercentage: {
    agent: 3.66,
    group: 4.21,
  },
  netIncomePosition: {
    group: 12,
    office: 3,
  },
  provisionPercentage: {
    agent: 15.22,
    group: 20.01,
  },
  baseSalary: {
    agent: 1989,
    group: 2300,
  },
  averageMonthlySalary: {
    agent: 2580.12,
    group: 3150.99,
  },
}, {
  agentId: '2221',
  averageMediationPercentage: {
    agent: 3.99,
    group: 4.29,
  },
  netIncomePosition: {
    group: 10,
    office: 2,
  },
  provisionPercentage: {
    agent: 13.22,
    group: 20.01,
  },
  baseSalary: {
    agent: 1189,
    group: 2300,
  },
  averageMonthlySalary: {
    agent: 2239.46,
    group: 3150.99,
  },
}, {
  agentId: '3090',
  averageMediationPercentage: {
    agent: 4.69,
    group: 4.21,
  },
  netIncomePosition: {
    group: 3,
    office: 1,
  },
  provisionPercentage: {
    agent: 16.88,
    group: 20.01,
  },
  baseSalary: {
    agent: 2200,
    group: 2300,
  },
  averageMonthlySalary: {
    agent: 3580.12,
    group: 3150.99,
  },
}, {
  agentId: 'A422',
  averageMediationPercentage: {
    agent: 3.44,
    group: 4.21,
  },
  netIncomePosition: {
    group: 14,
    office: 4,
  },
  provisionPercentage: {
    agent: 15.22,
    group: 20.01,
  },
  baseSalary: {
    agent: 1800,
    group: 2300,
  },
  averageMonthlySalary: {
    agent: 2300.52,
    group: 3150.99,
  },
}];

const overviewData = [{
  agentId: 'A110',
  data: 'A110 - Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum maiores modi quidem veniam, expedita quis laboriosam, ullam facere adipisci, iusto, voluptate sapiente corrupti asperiores rem nemo numquam fuga ab at.',
}, {
  agentId: '2221',
  data: '2221 - Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum maiores modi quidem veniam, expedita quis laboriosam, ullam facere adipisci, iusto, voluptate sapiente corrupti asperiores rem nemo numquam fuga ab at.',
}, {
  agentId: '3090',
  data: '3090 - Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum maiores modi quidem veniam, expedita quis laboriosam, ullam facere adipisci, iusto, voluptate sapiente corrupti asperiores rem nemo numquam fuga ab at.',
}, {
  agentId: 'A422',
  data: 'A422 - Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum maiores modi quidem veniam, expedita quis laboriosam, ullam facere adipisci, iusto, voluptate sapiente corrupti asperiores rem nemo numquam fuga ab at.',
}];

const contractData = [{
  agentId: 'A110',
  items: [{
    title: 'Tutkintotodistus',
    file: '',
  }],
}, {
  agentId: '2221',
  items: [{
    title: 'Työsopimus',
    file: '',
  }],
}, {
  agentId: '3090',
  items: [{
    title: 'Tutkintotodistus',
    file: '',
  }, {
    title: 'Työsopimus',
    file: '',
  }],
}, {
  agentId: 'A422',
  items: [{
    title: 'Irtisanoutumislomake',
    file: '',
  }],
}];

export default {
  name: 'GroupDashboardAgents',

  components: {
    'helmi-group-dashboard-agent-summary': () => import('@/components/groupDashboard/GroupDashboardAgentSummary'),
    'helmi-group-dashboard-card': () => import('@/components/groupDashboard/GroupDashboardCard'),
  },

  props: {
    colors: {
      type: Array,
      default: new Array(5),
    },
  },

  data: () => ({
    agentIndex: null,
    agentId: null,
    agents: [],
    fullscreen: false,
    initializing: true,
    processingData: false,
    summary: null,
    listOptions: {
      itemsPerPage: 5,
      page: 1,
    },
  }),

  computed: {
    ...mapState({
      agentProfit: 'agentProfit',
      theme: 'theme',
      loadingAgentProfit: 'loadingAgentProfit',
    }),
  },

  async mounted() {
    await this.initialize();
  },

  methods: {
    async displayAgentSummary(agent) {
      this.processingData = true;
      this.agentId = agent.id;

      const promises = [
        this.getSummary(agent.id),
        this.getOverview(agent.id),
        this.getContracts(agent.id),
      ];

      const options = {
        agent,
        promises,
      };

      this.processingData = false;

      EventBus.$emit('SHOW_SUMMARY', options);
    },

    /**
     * Gets the agents from an endpoint
     */
    async getAgents() {
      this.agents = await (new Promise((resolve) => {
        setTimeout(() => {
          resolve(agentData);
        }, 1500);
      }));
    },

    async getContracts(id) {
      const contracts = await (new Promise((resolve) => {
        setTimeout(() => {
          const match = contractData.find(s => s.agentId === id);
          resolve(match);
        }, 1000);
      }));

      return contracts;
    },

    async getOverview(id) {
      const overview = await (new Promise((resolve) => {
        setTimeout(() => {
          const match = overviewData.find(s => s.agentId === id);
          resolve(match);
        }, 500);
      }));

      return overview;
    },

    async getSummary(id) {
      const summary = await (new Promise((resolve) => {
        setTimeout(() => {
          const match = summaryData.find(s => s.agentId === id);
          resolve(match);
        }, 1000);
      }));

      return summary;
    },

    async initialize() {
      await this.getAgents();
      this.initializing = false;

      this.setAgentIndex();
    },

    /**
     * Sets the agentIndex based on the agent id (if set)
     */
    setAgentIndex() {
      if (!this.agentId) return;

      this.agentIndex = this.agents.findIndex(agent => agent.id === this.agentId);
    },
  },
};
</script>

<style lang="scss">
.theme--dark.v-list {
  background: rgba(100, 100, 100, 0.25);
}

.dark-theme .v-data-footer__select, .dark-theme .v-data-footer__pagination {
  color: #FFF !important;
}

.v-data-iterator.dark-theme {
    color: #FFF !important;
}

.v-data-iterator > div:not(.v-list) {
  padding-left: 8px;
}
</style>
